import { useGetStaffActivities } from 'common/queries-and-mutations/admin/staff';
import { Loader } from 'components/Loader';
import { format } from 'date-fns';
import React, { useMemo } from 'react';
import { groupActivities } from 'utils';

export default function StaffActivitySummary() {
  const { data, isLoading } = useGetStaffActivities();

  const activities = useMemo(() => {
    if (data) {
      return groupActivities(data);
    }
  }, [data]);

  const determineDateTime = (groupName: string, date: string) => {
    if (groupName === 'Today') {
      return format(new Date(date), 'K:mm aaa');
    } else if (groupName === 'Yesterday') {
      return format(new Date(date), 'K:mm aaa');
    } else {
      return format(new Date(date), 'dd MMMM yyyy K:mm aaa');
    }
  };

  return (
    <div>
      <div className="relative overflow-x-auto bg-white pb-11 sm:rounded-lg">
        <div className="mb-3 flex items-center justify-between">
          <div className="p-5 text-left text-lg font-semibold text-gray-900">
            Activity Summary
          </div>
        </div>
        {isLoading ? (
          <div className="mt-20 flex flex-col items-center justify-center">
            <Loader color={'#FF6606'} height={50} width={50} />
          </div>
        ) : (
          <div className="mx-9">
            {!activities?.length ? (
              <div className="text-center text-base font-medium">
                No Activities
              </div>
            ) : (
              <ol className="relative border-l-2 border-[#EAEEFD]">
                <div>
                  {activities &&
                    activities.map(group => {
                      const groupName = Object.keys(group)[0];
                      const activitiesInGroup = group[groupName];

                      return (
                        <ol
                          key={groupName}
                          className="relative border-l-2 border-[#EAEEFD]"
                        >
                          <li className="mb-5 ml-4 border-b border-[#F3F5F6]">
                            <div className="absolute -left-2 mt-1.5 h-3 w-3 rounded-full border border-white bg-[#FF6606]" />
                            <div className="mb-1 text-sm font-semibold leading-none text-[#353535]">
                              {groupName}
                            </div>
                          </li>
                          <ul>
                            {activitiesInGroup.map(activity => (
                              <li
                                key={activity.id}
                                className="mb-[25px] ml-4 border-b border-[#F3F5F6]"
                              >
                                <div className="absolute -left-2 mt-1.5 h-3 w-3 rounded-full border border-white bg-[#FF6606]" />
                                <div className="flex items-center justify-between">
                                  <div className="mb-1 text-sm font-normal leading-none text-[#353535] dark:text-gray-500">
                                    {activity.message
                                      .replace('You', 'Customer')
                                      .replace('your', 'his/her')}
                                  </div>
                                  <span className="text-xs font-normal text-[#353535]">
                                    {determineDateTime(
                                      groupName,
                                      activity.createdAt
                                    )}
                                  </span>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </ol>
                      );
                    })}
                </div>
              </ol>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
